import { NotebookPen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { UserNoteEntityType } from '@shared/schema';
import { openQuickNoteComposer } from '@/lib/noteEntityContext';

interface UserNotesPanelProps {
  entityType: UserNoteEntityType;
  entityId: number;
  notesUser?: string | null;
  className?: string;
}

/** Shared history view. Every capture opens the same recoverable composer. */
export function UserNotesPanel({
  entityType,
  entityId,
  notesUser,
  className = '',
}: UserNotesPanelProps) {
  const displayedNotes = notesUser ?? '';

  return (
    <div className={className} data-testid="user-notes-panel">
      <div className="mb-2 flex items-center gap-2">
        <NotebookPen className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
        <div>
          <p className="text-sm font-medium text-foreground">Note utente</p>
          <p className="text-xs text-muted-foreground">
            Memoria operativa letta anche da Martina. Ogni aggiunta resta nello stesso contesto.
          </p>
        </div>
      </div>

      <div
        className="mb-3 max-h-64 min-h-16 overflow-y-auto whitespace-pre-wrap rounded-lg border border-border bg-muted/20 p-3 text-sm leading-6 text-foreground"
        aria-label="Storico note utente"
      >
        {displayedNotes ? displayedNotes.split(/(\/files\?fileId=\d+)/g).map((part, index) => (
          /^\/files\?fileId=\d+$/.test(part)
            ? <a key={index} href={part} className="text-primary underline underline-offset-2">Apri documento CRM #{part.split('=')[1]}</a>
            : part
        )) : (
          <span className="text-muted-foreground">Nessuna nota ancora registrata.</span>
        )}
      </div>

      <Button
        type="button"
        onClick={() => openQuickNoteComposer({ entityType, entityId })}
      >
        Aggiungi o detta nota
      </Button>
    </div>
  );
}
